<app-navbar></app-navbar>

<router-outlet></router-outlet>

<simple-notifications></simple-notifications>
<div id="loading">
  <mat-spinner class="m-auto"></mat-spinner>
</div>
